module.exports = __webpack_public_path__ + "static/media/sc.ab4767bc.svg";